import { UserCog } from "lucide-react"
import { PlaceholderPage } from "./placeholder-page"

export function PermissionsSettingsPage() {
  return (
    <PlaceholderPage
      icon={UserCog}
      title="Uprawnienia"
      description="Konfiguruj uprawnienia dla poszczeg\u00F3lnych grup \u2014 dost\u0119pu do modu\u0142\u00F3w, operacji CRUD i widok\u00F3w."
    />
  )
}
